// Helper function to ensure coach avatar images use the latest URLs
// This handles cases where users have old URLs stored in their profiles

const IMAGE_URL_MAPPINGS: Record<string, string> = {
  // Old Owl URL -> New Owl URL
  "https://firebasestorage.googleapis.com/v0/b/drop-the-pitch.firebasestorage.app/o/CoachAvatars%2FOwl.png?alt=media&token=f1ee2b9a-fa2e-49bc-afc6-4bb965990166": 
    "https://firebasestorage.googleapis.com/v0/b/drop-the-pitch.firebasestorage.app/o/CoachAvatars%2FOwl.png?alt=media&token=0cb0e768-7a2b-442a-a4da-fab35a127cac",
};

/**
 * Get the current URL for a coach avatar image
 * If the provided URL is outdated, returns the updated URL
 * @param imageUrl - The stored image URL
 * @returns The current/updated image URL
 */
export function getCurrentCoachImageUrl(imageUrl: string): string {
  return IMAGE_URL_MAPPINGS[imageUrl] || imageUrl;
}
